import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Header from '../../components/Header'
import Paginate from '../../components/Paginate'
import Row from '../../components/Row'
import SectionHeader from '../../components/SectionHeader'
import UseStep from '../../components/UseStep'
import UseTip from '../../components/UseTip'

@observer
export default class UseContent extends Component {
  render() {
    return (
      <Fragment>
        {/* EYE DROPS USE */}
        <SectionHeader color="orange" icon="fas fa-tint" str="titles.eyeDropsUse" />
        {/* EYE DROPS USE - METHOD 1 */}
        <Header str="titles.method1" />
        <UseStep image="/images/use/method-1-step-1.jpg" str="prose.washYourHands" />
        <UseStep image="/images/use/method-1-step-2.jpg" str="prose.pullDownEyelid" />
        <UseStep image="/images/use/method-1-step-3.jpg" str="prose.restAFinger" />
        <UseStep image="/images/use/method-1-step-4.jpg" str="prose.lookingInMirror" />
        <UseStep image="/images/use/method-1-step-5.jpg" str="prose.closeEyesForMinute" />
        {/* EYE DROPS USE - METHOD 2 */}
        <Header str="titles.method2" />
        <UseStep image="/images/use/method-2-step-1.jpg" str="prose.washYourHands" />
        <UseStep image="/images/use/method-2-step-2.jpg" str="prose.layDownOnBack" />
        <UseStep image="/images/use/method-2-step-3.jpg" str="prose.restFingerCloseEyes" />
        <UseStep image="/images/use/method-2-step-4.jpg" str="prose.blinkUntilFeel" />
        <UseStep image="/images/use/method-2-step-5.jpg" str="prose.closeEyesForMinute" />
        {/* USAGE TIPS */}
        <SectionHeader color="orange" icon="fas fa-lightbulb" str="titles.usageTips" />
        {/* The images for these are out of order :/. */}
        {/* Right now, the order is: 1, 4, 2, 3, 5, 6. */}
        <UseTip image="/images/use/icon-tip-1.png" str="prose.orderDoesntMatter" />
        <UseTip image="/images/use/icon-tip-4.png" str="prose.waitFiveMinutes" />
        <UseTip image="/images/use/icon-tip-2.png" str="prose.takeDropsSameTime" />
        <UseTip image="/images/use/icon-tip-3.png" str="prose.putInYourDrop" />
        <UseTip image="/images/use/icon-tip-5.png" str="prose.dontWorrySpills" />
        <UseTip image="/images/use/icon-tip-6.png" str="prose.checkRefrigeration" />
        {/* PDF DOWNLOADS */}
        <SectionHeader color="orange" icon="fas fa-download" str="titles.pdfDownloads" />
        <Card>
          <Card.Title str="titles.downloadPDF" />
          <Card.Pad>
            <Row>
              <Row.Cell>
                <Button
                  color="orange"
                  str="titles.method1"
                  onClick={() => window.open('/documents/use-method-1.pdf', '_blank')}
                />
              </Row.Cell>
              <Row.Cell>
                <Button
                  color="orange"
                  str="titles.method2"
                  onClick={() => window.open('/documents/use-method-2.pdf', '_blank')}
                />
              </Row.Cell>
              <Row.Cell>
                <Button
                  color="orange"
                  str="titles.both"
                  onClick={() => window.open('/documents/use-both-methods.pdf', '_blank')}
                />
              </Row.Cell>
            </Row>
          </Card.Pad>
        </Card>
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button prev
            color="blue"
            str="titles.learn"
            to="/patient-session/learn"
          />
          <Paginate.Button next
            color="red"
            str="titles.goal"
            to="/patient-session/goal"
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PatientSession/UsePage.js